/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prefer-const */
/* eslint-disable react/destructuring-assignment */
import {
  CloseCircleFilled,
  FilePdfOutlined,
  PhoneOutlined,
  PlusOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Badge,
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  Modal,
  Popover,
  Select,
  Skeleton,
  Spin,
  TimePicker,
  Tooltip,
  message,
} from "antd";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CREATE_SCHEDULED_EMAIL,
  CREATE_SCHEDULED_MESSAGE,
  SAVE_AS_DRAFT,
  UPDATE_SCHEDULED_EMAIL,
} from "../../../graphql/mutation";
import {
  GET_EMAIL_TEMPLATE_LISTING,
  GET_ENGAGEMENT_TEMPLATE_TEXT,
  GET_INITIAL_REVIEW_MESSAGE,
  GET_SCHEDULED_EMAILS_FOR_LEAD,
} from "../../../graphql/query";
import useDebounce from "../../../hooks/debounceHook";
import useLang from "../../../hooks/useLang";
import AppointmentIcon from "../../../icons/js/AppointmentIcon";
import AttachmentIcon from "../../../icons/js/AttachmentIcon";
import { BottomCalendarIcon } from "../../../icons/js/CalendarIcon";
import CarIcon from "../../../icons/js/CarIcon";
import DeleteIcon from "../../../icons/js/DeleteIcon";
import { CodeBrackets, EmailWithSearch, SignatureIcon } from "../../../icons/js/EmailIcons";
import GIFIcon from "../../../icons/js/GIFIcon";
import NotesIcon from "../../../icons/js/NotesIcon";
import OttoLinkIcon from "../../../icons/js/OttoLinkIcon";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";
import { PhoneIconJSX } from "../../../icons/js/PhoneIconJSX";
import { RemainderIcon21 } from "../../../icons/js/RemainderIcon";
import ReviewTemplateIcon from "../../../icons/js/ReviewTemplateIcon";
import SendIcon from "../../../icons/js/SendIcon";
import SmilyIconJSX from "../../../icons/js/SmilyIcon";
import TemplateIcon from "../../../icons/js/TemplateIcon";
import { AccessPermissionAction, timezones } from "../../../library/constants";
import { checkAccessPermission, openDialog } from "../../../library/helpers";
import { addScheduledMessage } from "../../../redux/slices/leadSlice";
import { handleMediaEvent } from "./engagementActivity";
import EmojiPicker from "./mediaSharing/emojiPicker";
import GifPickerComponent from "./mediaSharing/gifPicker";
import MmsMediaButtons from "./mmsMediaButtons";
import ScheduleMessagesPopup from "./scheduleMessagesPopup";
import { ScheduledJSX } from "./Emails";

export function BottomActions({
  handleFiles,
  fetchData,
  setMediaUploadLoader,
  handleMMS,
  emailForm,
  onlyFirstMessage,
  onClickHandler,
  tooltipTitle,
  afterMessageConsent,
  setCallConsentMessage,
  sendConsentMessage,
  isConsentStatusEnable,
  attachments,
  handleMediaSharing,
  mediaRef,
  videoRef,
  documentRef,
  setAttachments,
  text,
  selectedLead,
  user,
  setTemplateModal,
  showReviewRequestButton = true,
  setmessageText,
  setisReview,
  activeOppName,
  textMode,
  messageText,
  handleSetDefinedTemplate,
  handleAddAppointment,
  scheduledMessages,
  getMessages,
  setrichTextValue,
  richTextValue,
  buttonDisabled,
  messageLoader,
  loading,
  spinner,
  leadsLoading,
  mmsLoader,
  buttonStyle,
  setmmsLoader,
  setSummaryVisible,
  summaryVisible,
  setscheduledMessageDrawer,
  crmIntegrationType,
  opportunityList,
  addSignature,
  emailCursor,
  emailTextRef,
}) {
  const [lang] = useLang();
  const [loaderFn, setloaderFn] = useState(false);
  const [selectedScheduleEmail, setselectedScheduleEmail] = useState(null);
  const [scheduleMessageForm, setscheduleMessageForm] = useState({
    open: false,
    textMode: "Message",
    mode: "ADD",
  });
  const { textMode: textModeRedux } = useSelector(state => state.lead);
  const { email } = useSelector(state => state.user);
  const popoverRef = useRef(null);
  const schedulePopupRef = useRef();
  const dispatch = useDispatch();
  const [getMessageText, { loading: appointmentLinkLoading }] = useLazyQuery(
    GET_ENGAGEMENT_TEMPLATE_TEXT,
    {
      fetchPolicy: "cache-first",
    }
  );
  const [createScheduledMessage, { loading: createScheduledMessageLoader }] =
    useMutation(CREATE_SCHEDULED_MESSAGE);
  const canShareVDP = checkAccessPermission(AccessPermissionAction.VDP_FEATURE_VIEW);

  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const handleInsertLink = urlString => {
    const editor = document.getElementById("rich-text");
    editor.focus(); // Ensure editor is focused

    if (!emailCursor) return; // If no cursor position saved, do nothing

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(emailCursor); // Restore cursor position

    // Split the URL string into individual URLs
    const urls = urlString.split("\n");
    // Insert each hyperlink at the restored cursor position
    urls.forEach(url => {
      const range = selection.getRangeAt(0);
      range.deleteContents(); // Remove any selected text

      const linkNode = document.createElement("a");
      linkNode.href = url.trim(); // Ensure no extra spaces in the URL
      linkNode.textContent = url.trim();
      linkNode.target = "_blank"; // Open link in a new tab
      range.insertNode(linkNode);

      // Add a line break after each link
      const lineBreakNode = document.createElement("br");
      range.insertNode(lineBreakNode);

      // Add a space after the line break
      const spaceNode = document.createTextNode("\n");
      range.insertNode(spaceNode);

      // Move cursor after the space
      range.setStartAfter(spaceNode);
      range.setEndAfter(spaceNode);
    });

    // Clear selection to avoid merging all links into one line
    selection.removeAllRanges();
  };

  const handleInsertSnippet = snippet => {
    const editor = document.getElementById("rich-text");
    editor.focus(); // Ensure editor is focused

    if (!emailCursor) return; // If no cursor position saved, do nothing

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(emailCursor); // Restore cursor position

    // Insert snippet at restored cursor position
    const range = selection.getRangeAt(0);
    range.deleteContents(); // Remove any selected text

    const snippetNode = document.createTextNode(snippet);
    range.insertNode(snippetNode);

    // Move cursor after snippet
    range.setStartAfter(snippetNode);
    range.setEndAfter(snippetNode);
    selection.removeAllRanges();
    selection.addRange(range);
  };
  const handleSendAppointmentLink = async () => {
    const res = await getMessageText({
      variables: {
        leadId: selectedLead.id,
        content: `${text.current.value} {createAppointmentUrl}`,
      },
    });
    if (res.data.getEngagementTemplateText.statusCode === 200) {
      setmessageText(res.data.getEngagementTemplateText.content);
      if (textModeRedux === "Email") {
        handleInsertLink(res?.data?.getEngagementTemplateText?.content || "");
      } else {
        text.current.value = res.data.getEngagementTemplateText.content;
      }
    } else {
      message.error(res.data.getEngagementTemplateText.message);
    }
  };
  const Attachments = () => {
    return (
      <div className="flex flex-col justify-center  gap-5">
        {!attachments.some(file => file?.file?.type?.includes("gif") || false) && (
          <MmsMediaButtons
            color="#64748B"
            handleMediaSharing={handleMediaSharing}
            mediaRef={mediaRef}
            videoRef={videoRef}
            documentRef={documentRef}
            handleMediaEvent={e => handleMediaEvent(e, attachments, setAttachments)}
          />
        )}{" "}
        {attachments.length === 0 && (
          <div key="gifPicker" className="icon-wrapper">
            <Popover
              showArrow={false}
              content={
                <GifPickerComponent
                  attachments={attachments}
                  setAttachments={setAttachments}
                  selectedLead={selectedLead}
                  user={user}
                />
              }
              trigger="click"
              destroyTooltipOnHide
            >
              <span className="flex items-center justify-start cursor-pointer">
                <GIFIcon className="text-[20px] mr-1.5" />
                Select GIF
              </span>
            </Popover>
          </div>
        )}{" "}
      </div>
    );
  };
  const [getReviewMessage, { loading: reviewInviteLoading }] = useLazyQuery(
    GET_INITIAL_REVIEW_MESSAGE,
    {
      fetchPolicy: "network-only",
    }
  );
  const handleReviewInvite = async () => {
    const res = await getReviewMessage({
      variables: {
        leadId: selectedLead.id,
        leadOpportunityId: +activeOppName?.id,
      },
    });
    if (res?.data?.getInitialReviewMessage?.statusCode === 200) {
      if (textModeRedux === "Email") {
        handleInsertSnippet(res?.data?.getInitialReviewMessage?.content);
      } else {
        text.current.value = res?.data?.getInitialReviewMessage?.content;
        setmessageText(res?.data?.getInitialReviewMessage?.content);
      }
      setisReview(true);
    } else {
      message.error("Failed to generate review message. Please contact support.");
    }
  };
  const OttoLinks = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        {crmIntegrationType === "EL" && (
          <span
            onClick={() => {
              openDialog("documentSelector", {
                width: "620px",
                dialogHeader: "Print Dealer Documents",
                leadId: selectedLead?.id,
                activeOppName: activeOppName,
                opportunityList: opportunityList,
              });
            }}
            className="flex items-center justify-start cursor-pointer"
          >
            <FilePdfOutlined className="text-[20px] mr-1.5" />
            Print Dealer Document
          </span>
        )}

        <span
          onClick={() => handleSendAppointmentLink()}
          className="flex items-center justify-start cursor-pointer"
        >
          <BottomCalendarIcon className="text-[20px] mr-1.5" />
          Attach Appointment Link
        </span>
        {showReviewRequestButton && (
          <span
            onClick={() => handleReviewInvite()}
            className="flex items-center justify-start cursor-pointer"
          >
            <ReviewTemplateIcon className="text-[20px] mr-1.5" />
            Review Invite
          </span>
        )}
        {textModeRedux === "Text" && (
          <span
            onClick={() => setTemplateModal({ visible: true })}
            className="flex items-center justify-start cursor-pointer"
          >
            <TemplateIcon className="text-[20px] mr-1.5" />
            Select Template
          </span>
        )}
        {canShareVDP && (
          <span
            onClick={() => {
              openDialog("vdpSelect", {
                width: "620px",
                dialogHeader: "Select Vehicle From Inventory",
                text,
                setmessageText,
                handleInsertLink,
              });
            }}
            className="flex items-center justify-start cursor-pointer"
          >
            <CarIcon color="#64748B" className="text-[20px] mr-1.5" />
            VDP
          </span>
        )}
      </div>
    );
  };
  const CallLinks = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          // onClick={() => handleSendReviewClick()}
          className="flex items-center justify-start cursor-pointer"
        >
          <PhoneOutlined className="text-[20px] rotate-90 mr-1.5" />
          Voice Call
        </span>
        <span
          // onClick={() => setTemplateModal(true)}
          className="flex items-center justify-start cursor-pointer"
        >
          <VideoCameraOutlined className="text-[20px] mr-1.5" />
          Video Call
        </span>
      </div>
    );
  };

  const Signature = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          // onClick={() => handleSendReviewClick()}
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "EDIT",
              addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <EditPencilIcon color="#334155" className="text-[20px] mr-1.5" />
          Edit Signature
        </span>
        <span
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "ADD",
              addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <PlusOutlined className="text-[20px] mr-1.5" />
          Insert Signature
        </span>
      </div>
    );
  };
  const InsertFields = () => {
    const [search, setsearch] = useState("");
    const arr = [
      "{dealerName}",
      "{companyName}",
      "{leadOwner}",
      "{userFullName}",
      "{userName}",
      "{userFirstName}",
      "{userLastName}",
      "{fullName}",
      "{firstName}",
      "{lastName}",
      "{leadFullName}",
      "{leadFirstName}",
      "{leadLastName}",
      "{sourceName}",
      "{previousVehicle}",
      "{currentVehicle}",
      "{vehicleOfInterest}",
      "{primaryVehicle}",
      "{locationName}",
      "{locationAddress}",
      "{locationUrl}",
      "{createAppointmentUrl}",
    ];
    return (
      <div>
        <Input
          onChange={e => setsearch(e.target.value)}
          onClick={e => e.stopPropagation()}
          placeholder="Search snippets"
        />
        <div className="flex-col-centered gap-2 overflow-y-auto h-[200px]">
          {arr
            .filter(item =>
              isEmpty(search) ? item : item.toLowerCase().includes(search.toLowerCase())
            )
            .map((item, index) => (
              <span
                onClick={e => {
                  e.stopPropagation();
                  handleInsertSnippet(item);
                }}
                className="cursor-pointer"
                key={index}
              >
                {item}
              </span>
            ))}
        </div>
      </div>
    );
  };
  const EmailTemplate = () => {
    const [emailTemplates, setemailTemplates] = useState([]);
    const [search, setsearch] = useState("");
    const { loading: emailTemplateLoader } = useQuery(GET_EMAIL_TEMPLATE_LISTING, {
      variables: {
        companyId: user.company.id,
      },
      onCompleted: res => {
        const activeTemplates = res.getCompanyEmailTemplateEvent;
        setemailTemplates(
          activeTemplates.filter(template => template.companyEmailTemplateEvent.isActive)
        );
      },
    });
    const [getEngagementTemplateText] = useLazyQuery(GET_ENGAGEMENT_TEMPLATE_TEXT);
    const parseTemplate = async template => {
      const payload = {
        content: template.companyEmailTemplateEvent.templateText,
        leadId: selectedLead.id,
      };
      const res = await getEngagementTemplateText({
        variables: payload,
      });
      emailTextRef.current.innerHTML = res?.data?.getEngagementTemplateText?.content;
      emailForm.setFieldValue("subject", template.companyEmailTemplateEvent.subjectText);
    };
    return (
      <div className="p-2">
        <Input onClick={e => e.stopPropagation()} onChange={e => setsearch(e.target.value)} />
        <div className="flex-col-centered gap-1 mt-1">
          <Skeleton loading={emailTemplateLoader} active paragraph={{ rows: 4 }}>
            {emailTemplates.map((option, index) => (
              <span
                key={index}
                onClick={e => {
                  // e.stopPropagation();
                  parseTemplate(option);
                }}
                className="p-1 cursor-pointer"
              >
                {option.companyEmailTemplateEvent.title || ""}
              </span>
            ))}
          </Skeleton>
        </div>
      </div>
    );
  };
  const OptoutErrorMessage = "Lead has opted out, you cannot message this lead now!";
  const ErrorPopover = <Alert type="error" showIcon message={OptoutErrorMessage} />;

  const bottomActions = [
    {
      render: (
        <EmojiPicker
          key={`emjoi_picker_${selectedLead?.id}`}
          textMode={textMode}
          handleSetDefinedTemplate={handleSetDefinedTemplate}
          text={text}
          messageText={messageText}
          emailCursor={emailCursor}
          emailTextRef={emailTextRef}
        />
      ),
      title: "Emoji",
      icon: <SmilyIconJSX color="black" />,
      autoCloseDisabled: true,
    },
    {
      render: <Attachments />,
      icon: <AttachmentIcon color="black" />,
      title: "Attach File",
    },
    {
      render: <OttoLinks />,
      icon: <OttoLinkIcon color="black" />,
      title: "Otto Links",
    },
    ...(textModeRedux === "Text"
      ? [
          {
            render: <CallLinks />,
            icon: <PhoneIconJSX color="black" />,
            title: "Audio & video call",
          },
          {
            render: null,
            icon: (
              <AppointmentIcon
                color="black"
                onClick={e =>
                  buttonDisabled() ? message.error(OptoutErrorMessage) : handleAddAppointment(e)
                }
                showBG
                bgColor="#E2E8F0"
              />
            ),
            title: "Add Appointment",
          },
          {
            icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
            hover: false,
          },
          {
            icon: (
              <span className="flex-row-centered gap-1 items-center">
                <NotesIcon
                  onClick={() =>
                    setSummaryVisible(prev => ({
                      visible: true,
                      count: prev.count + 1,
                    }))
                  }
                />
                {summaryVisible.visible && (
                  <CloseCircleFilled
                    className="text-[#64748B] cursor-pointer"
                    onClick={() => setSummaryVisible({ visible: false, count: 0 })}
                  />
                )}
              </span>
            ),
            render: null,
            title: "Conversation summary",
          },
        ]
      : canSendEmail
      ? [
          // {
          //   icon: <SignatureIcon />,
          //   render: <Signature />,
          //   title: "Add Signature",
          // },
          {
            icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
            hover: false,
          },
          {
            icon: (
              <span className="flex-row-centered items-center gap-[7px]">
                <EmailWithSearch />
                <span className="text-grey-700 font-[400]">Use Template</span>
              </span>
            ),
            render: <EmailTemplate />,
            title: "Use Template",
          },
          {
            icon: (
              <span className="flex-row-centered items-center gap-[7px]">
                <CodeBrackets />
                <span className="text-grey-700 font-[400]">Insert Fields</span>
              </span>
            ),
            title: "Insert Fields",
            render: <InsertFields />,
          },
        ]
      : []),
  ];
  const [createScheduledEmail] = useMutation(CREATE_SCHEDULED_EMAIL);
  const [updateScheduledEmail] = useMutation(UPDATE_SCHEDULED_EMAIL);
  const handleQuickSchedule = async (date, mode) => {
    try {
      const isEmail = mode === "Email";
      // console.log("handleQuickSchedule => Called");
      if (isEmail) {
        if (emailForm.getFieldValue("subject") === "" || emailTextRef.current.innerHTML === "") {
          return message.error("Please enter the subject and body of the email");
        }
        // console.log("handleQuickSchedule:attachments", attachments);
        let mmsArr = [];
        if (attachments.length > 0) {
          mmsArr = await handleFiles(
            attachments.filter(file => file.mediaUrl.includes("localhost")),
            user,
            selectedLead,
            fetchData,
            setMediaUploadLoader
          );
        }
        const payload = {
          subject: emailForm.getFieldValue("subject"),
          body: emailTextRef.current.innerHTML,
          leadId: selectedLead.id,
          to: emailForm.getFieldValue("to"),
          scheduledDate: date,
          timezone: dayjs.tz.guess(),
          id: selectedScheduleEmail?.id,
          attachments: [
            ...mmsArr,
            ...attachments.filter(file => !file.mediaUrl.includes("localhost")),
          ],
        };
        if (selectedScheduleEmail?.id) {
          const scheduleEmailRes = await updateScheduledEmail({
            variables: payload,
          });
          if (scheduleEmailRes.data.updateScheduledEmail.statusCode === 200) {
            message.success(scheduleEmailRes.data.updateScheduledEmail.message);
            emailForm.resetFields();
            emailTextRef.current.innerHTML = "";
            setselectedScheduleEmail(null);
            getMessages();
            return true;
          }
          message.error(scheduleEmailRes.data.updateScheduledEmail.message);
          return false;
        }
        const scheduleEmailRes = await createScheduledEmail({
          variables: payload,
        });
        if (scheduleEmailRes.data.createScheduledEmail.statusCode === 200) {
          message.success(scheduleEmailRes.data.createScheduledEmail.message);
          emailForm.resetFields();
          emailTextRef.current.innerHTML = "";
          setselectedScheduleEmail(null);
          getMessages();
          return true;
        }
        message.error(scheduleEmailRes.data.createScheduledEmail.message);
        return false;
      }
      if (text.current.value === "") {
        return message.error("Please enter a message first");
      }
      const obj = {
        leadId: selectedLead?.id,
        message: text.current.value,
        scheduledDate: date,
        timezone: dayjs.tz.guess(),
      };
      const res = await createScheduledMessage({
        variables: { ...obj },
      });
      if (res.data.createScheduledMessage.statusCode === 200) {
        setTimeout(() => {
          text.current.value = "";
          text.current.style.height = "0px";
          setmessageText("");
        }, 1000);
        message.success(res.data.createScheduledMessage.message);
        getMessages();
        dispatch(addScheduledMessage(res.data.createScheduledMessage.scheduledMessage));
      } else {
        message.error(res.data.createScheduledMessage.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [scheduledEmails, setscheduledEmails] = useState([]);
  const [scheduleEmailDrawer, setscheduleEmailDrawer] = useState({
    visible: false,
    emails: [],
  });
  const { refetch: refetchScheduledEmailsForLead } = useQuery(GET_SCHEDULED_EMAILS_FOR_LEAD, {
    variables: {
      leadId: selectedLead.id,
    },
    skip: !selectedLead?.id,
    onCompleted: res => {
      setscheduledEmails(res.getScheduledEmailsForLead);
    },
  });
  const refetchScheduledEmailsForLeadHandler = async () => {
    const res = await refetchScheduledEmailsForLead();
    if (res.data.getScheduledEmailsForLead) {
      setscheduledEmails(res.data.getScheduledEmailsForLead);
    }
  };
  const sendMenu = mode => {
    const isEmail = mode === "Email";
    const close = () => schedulePopupRef.current.click();
    return (
      <div className="flex flex-col items-start gap-2" onClick={e => e.stopPropagation()}>
        <span className="text-sm text-[#64748B] font-[400] ">Schedule {mode}</span>
        <span
          className="text-[16px] font-[400] text-grey-700 cursor-pointer "
          onClick={async () => {
            const res = await handleQuickSchedule(
              dayjs()
                .add(1, "day")
                .set("hour", 9)
                .set("minute", 0)
                .set("second", 0)
                .format("YYYY-MM-DDTHH:mm:ss"),
              mode
            );
            if (res) refetchScheduledEmailsForLeadHandler();
            close();
          }}
        >
          Tomorrow at 9:00 AM
        </span>
        <span
          onClick={async () => {
            const res = await handleQuickSchedule(
              dayjs()
                .day(8)
                .set("hour", 9)
                .set("minute", 0)
                .set("second", 0)
                .format("YYYY-MM-DDTHH:mm:ss"),
              mode
            );
            if (res) refetchScheduledEmailsForLeadHandler();
            close();
          }}
          className="text-[16px] font-[400] text-grey-700 cursor-pointer "
        >
          Monday at 9:00 AM
        </span>
        <span
          onClick={() => {
            if (isEmail) {
              if (
                emailForm.getFieldValue("subject") === "" ||
                emailTextRef.current.innerHTML === ""
              ) {
                return message.error("Please enter the subject and body of the email");
              }
              setscheduleMessageForm({ open: true, textMode: mode, mode: "ADD" });
              close();
            } else {
              if (text.current.value === "") return message.error("Please enter a message first");
              setscheduleMessageForm({ open: true, textMode: mode, mode: "ADD" });
              close();
            }
          }}
          className="text-[16px] font-[400] text-grey-700 cursor-pointer"
        >
          Select custom date & time
        </span>
        {isEmail
          ? scheduledEmails.length > 0 && (
              <>
                <div className="h-[1px] w-full bg-[#CBD5E1]" />
                <span
                  className="cursor-pointer text-[16px] font-[500] text-brand-500"
                  onClick={() => {
                    // setscheduledMessageDrawer({ open: true, messages: scheduledMessages });
                    setscheduleEmailDrawer({ visible: true, emails: scheduledEmails });
                    close();
                  }}
                >
                  Scheduled Emails ({scheduledEmails.length})
                </span>
              </>
            )
          : scheduledMessages.length > 0 && (
              <>
                <div className="h-[1px] w-full bg-[#CBD5E1]" />
                <span
                  className="cursor-pointer text-[16px] font-[500] text-brand-500"
                  onClick={() => {
                    setscheduledMessageDrawer({ open: true, messages: scheduledMessages });
                    close();
                  }}
                >
                  Scheduled Messages ({scheduledMessages.length})
                </span>
              </>
            )}
      </div>
    );
  };
  const hasConsent = isConsentStatusEnable(
    selectedLead?.textConsentStatus,
    user?.company?.isOptinConsentMethod
  );
  const consent = useMemo(() => selectedLead?.textConsentStatus, [selectedLead]);
  const { selectedEmail } = useSelector(state => state.lead);
  const [saveAsDraft, { loading: saveAsDraftLoader }] = useMutation(SAVE_AS_DRAFT);
  const [draftSaved, setdraftSaved] = useState(false);

  const saveDraft = async () => {
    // console.log("========== saveDraft", email);
    if (email.email !== "" && email.subject !== "") {
      try {
        await saveAsDraft({
          variables: {
            draftType: "EMAIL",
            leadId: selectedLead.id,
            companyId: user.company.id,
            locationId: sessionStorage.getItem("currentLocationId").includes(",")
              ? null
              : sessionStorage.getItem("currentLocationId"),
            userId: user.id,
            body: email.body,
            subject: email.subject,
            receiver: email.email,
          },
        });
        setdraftSaved(true);
      } catch (error) {
        console.error("Error saving draft:", error);
      }
    }
  };

  // Create debounced version of your function (800ms delay)
  const debouncedSaveDraft = useDebounce(saveDraft, 2 * 1000, [email]);

  useEffect(() => {
    // console.log("========== email", email);
    debouncedSaveDraft();
  }, [email]);

  return (
    <Spin spinning={reviewInviteLoading || appointmentLinkLoading}>
      <div className="flex-row-centered justify-between w-full p-2">
        <div className="flex-row-centered gap-2 items-center">
          {hasConsent &&
            bottomActions.map((item, index) => {
              const actionProps = {
                buttonDisabled,
                ErrorPopover,
                item,
                hover: item.hover ?? true,
                index,
              };
              return <Actions key={index} {...actionProps} />;
            })}
        </div>
        <div className="flex-row-centered gap-3 items-center">
          {draftSaved && textModeRedux !== "Text" && (
            <span className="italic text-grey-100 flex-row-centered gap-1">
              {saveAsDraftLoader ? "Saving Draft..." : "Draft Saved"}
            </span>
          )}
          {hasConsent && (
            <Tooltip title={textModeRedux === "Text" ? "Schedule message" : "Schedule an email"}>
              <Popover
                trigger={["click"]}
                content={
                  buttonDisabled()
                    ? ErrorPopover
                    : textModeRedux === "Text"
                    ? sendMenu("Message")
                    : sendMenu("Email")
                }
              >
                <Badge
                  className="testing"
                  count={
                    textModeRedux === "Text" ? scheduledMessages.length : scheduledEmails.length
                  }
                  size="small"
                >
                  <span
                    className="px-1 flex-row-centered justify-center cursor-pointer hover:bg-[#E2E8F0] rounded-[4px] p-1"
                    type="text"
                    ref={schedulePopupRef}
                  >
                    <RemainderIcon21 color="black" />
                  </span>
                </Badge>
              </Popover>
            </Tooltip>
          )}
          <Tooltip title={tooltipTitle()}>
            <Button
              className="flex-row-centered gap-1 text-white items-center rounded-[4px]"
              type="primary"
              key={`attach_btn_${selectedLead?.id}`}
              onClick={async () => {
                if (mmsLoader) {
                  return message.info("Please wait while we complete the current process");
                }
                let mmsArr = [];
                if (attachments.length > 0 && textModeRedux !== "Email") {
                  setmmsLoader(true);
                  mmsArr = await handleFiles(
                    attachments,
                    user,
                    selectedLead,
                    fetchData,
                    setMediaUploadLoader
                  );
                }
                if (textModeRedux === "Email") {
                  return emailForm.submit();
                }
                if (mmsArr && mmsArr?.length > 0) {
                  return handleMMS(mmsArr);
                }
                if (
                  isConsentStatusEnable(
                    selectedLead?.textConsentStatus,
                    user?.company?.isOptinConsentMethod
                  )
                ) {
                  if (
                    isEmpty(messageText.trim()) &&
                    isEmpty(textMode === 0 ? text.current.value : richTextValue)
                  ) {
                    return message.error(lang.pleaseEnterMessageToSend);
                  }
                  setmessageText(textMode === 0 ? text.current.value : richTextValue);
                  let msg;
                  if (onlyFirstMessage) {
                    if (selectedLead?.messages?.length > 0) {
                      msg = text.current?.value.trim() || messageText.trim();
                    } else {
                      msg =
                        afterMessageConsent !== ""
                          ? `${
                              textMode === 0 ? text.current.value.trim() : richTextValue.trim()
                            } ${afterMessageConsent}`
                          : textMode === 0
                          ? text.current.value.trim()
                          : richTextValue.trim();
                    }
                  } else {
                    msg =
                      afterMessageConsent !== ""
                        ? `${
                            textMode === 0 ? text.current.value.trim() : richTextValue.trim()
                          } ${afterMessageConsent}`
                        : textMode === 0
                        ? text.current.value.trim()
                        : richTextValue.trim();
                  }
                  onClickHandler(msg, selectedLead, user?.id);
                } else {
                  setCallConsentMessage(true);
                  sendConsentMessage();
                }
              }}
              style={{ ...buttonStyle(), padding: "5px" }}
              loading={messageLoader || loaderFn || mmsLoader}
              disabled={
                buttonDisabled() ||
                !selectedLead?.id ||
                messageLoader ||
                loading ||
                spinner ||
                leadsLoading ||
                textMode !== 0 ||
                loaderFn ||
                (textModeRedux === "Email" && !selectedEmail?.email)
              }
            >
              Send <SendIcon color="white" />
            </Button>
          </Tooltip>
        </div>
        <Modal
          footer={null}
          className="normal-popup"
          onCancel={() => setscheduleMessageForm({ open: false })}
          title={`Schedule ${scheduleMessageForm.textMode}`}
          open={scheduleMessageForm.open}
        >
          {scheduleMessageForm.textMode === "Email" ? (
            <EmailSchedule
              popoverRef={schedulePopupRef}
              emailForm={emailForm}
              emailTextRef={emailTextRef}
              selectedLead={selectedLead}
              getMessages={getMessages}
              mode={scheduleMessageForm.mode}
              close={() => setscheduleMessageForm({ open: false })}
              refetch={refetchScheduledEmailsForLeadHandler}
              selectedScheduleEmail={selectedScheduleEmail}
              setselectedScheduleEmail={setselectedScheduleEmail}
              updateScheduledEmail={updateScheduledEmail}
            />
          ) : (
            <ScheduleMessagesPopup
              messageData={{
                message: textMode === 0 ? text?.current?.value : richTextValue,
                taskSendDatetime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
              }}
              close={() => setscheduleMessageForm({ open: false })}
              mode="ADD"
              scheduledMessages={scheduledMessages}
              selectedLead={selectedLead}
              getMessages={getMessages}
              setmessageText={setmessageText}
              reset={() => {
                const resetText = () => {
                  text.current.value = "";
                };
                if (textMode === 0) {
                  resetText();
                } else {
                  setrichTextValue("");
                }
              }}
            />
          )}
        </Modal>
        <Drawer
          open={scheduleEmailDrawer.visible}
          width="50%"
          title="Scheduled Emails"
          onClose={() => setscheduleEmailDrawer({ visible: false, emails: [] })}
        >
          <ScheduledJSX
            handleEdit={email => {
              setselectedScheduleEmail(email);
              emailTextRef.current.innerHTML = email.body;
              emailForm.setFieldsValue({ to: email.to });
              emailForm.setFieldsValue({ subject: email.subject });
              setscheduleEmailDrawer({ visible: false, emails: [] });
            }}
            emails={scheduleEmailDrawer.emails}
            showBody
            showHeader={false}
          />
        </Drawer>
      </div>
    </Spin>
  );
}
export function Actions({ item, hover, buttonDisabled, ErrorPopover }) {
  const [tooltipVisible, settooltipVisible] = useState(false);
  const tooltipRef = useRef(null);
  // Prepare shared hover styles
  const isHoverable = hover !== false; // Treat undefined as true

  return item?.render ? (
    <Popover
      trigger="click"
      content={
        <span onClick={() => !item?.autoCloseDisabled && tooltipRef.current.click()}>
          {buttonDisabled() ? ErrorPopover : item.render}
        </span>
      }
    >
      <Tooltip open={tooltipVisible} title={item.title}>
        <span
          className={`flex-row-centered p-1 items-center justify-center ${
            hover && "hover:bg-[#E2E8F0] cursor-pointer"
          } rounded-[4px]`}
          onMouseEnter={() => hover && settooltipVisible(true)}
          onMouseLeave={() => settooltipVisible(false)}
          onClick={() => settooltipVisible(false)}
          ref={tooltipRef}
        >
          {item.icon}
        </span>
      </Tooltip>
    </Popover>
  ) : (
    <Tooltip open={tooltipVisible} title={item.title}>
      <span
        className={`flex-row-centered p-1 items-center justify-center rounded-[4px] ${
          isHoverable ? "hover:bg-[#E2E8F0] !cursor-pointer transition-colors duration-150" : ""
        }`}
        onMouseEnter={() => hover && settooltipVisible(true)}
        onMouseLeave={() => settooltipVisible(false)}
        onClick={() => settooltipVisible(false)}
        ref={tooltipRef}
      >
        {item.icon}
      </span>
    </Tooltip>
  );
}
export const EmailSchedule = ({
  popoverRef,
  emailForm,
  emailTextRef,
  selectedLead,
  getMessages,
  mode = "ADD",
  close,
  refetch,
  selectedScheduleEmail,
  updateScheduledEmail,
  setselectedScheduleEmail,
}) => {
  const [scheduleForm] = Form.useForm();
  const [createScheduledEmail, { loading: createScheduledEmailLoader }] =
    useMutation(CREATE_SCHEDULED_EMAIL);
  const handleSchedule = async values => {
    const timeComponents = dayjs(values.time);
    const hours = timeComponents.hour();
    const minutes = timeComponents.minute();
    const seconds = timeComponents.second();
    const milliseconds = timeComponents.millisecond();
    const timeStamp = dayjs(values.date)
      .hour(hours)
      .minute(minutes)
      .second(seconds)
      .millisecond(milliseconds)
      .toISOString();

    if (isEmpty(emailForm.getFieldValue("subject")) || emailTextRef.current.innerHTML === "") {
      return message.error("Please enter the subject and body of the email");
    }
    const payload = {
      scheduledDate: timeStamp,
      timezone: values.timezone,
      subject: emailForm.getFieldValue("subject"),
      body: emailTextRef.current.innerHTML,
      leadId: selectedLead.id,
      to: emailForm.getFieldValue("to"),
      id: selectedScheduleEmail?.id,
    };
    // console.log("===> EmailSchedule:payload", payload);
    if (selectedScheduleEmail?.id) {
      const scheduleEmailRes = await updateScheduledEmail({
        variables: payload,
      });
      if (scheduleEmailRes.data.updateScheduledEmail.statusCode === 200) {
        message.success(scheduleEmailRes.data.updateScheduledEmail.message);
        emailForm.resetFields();
        emailTextRef.current.innerHTML = "";
        setselectedScheduleEmail(null);
        getMessages();
      } else {
        message.error(scheduleEmailRes.data.updateScheduledEmail.message);
      }
    } else {
      const res = await createScheduledEmail({
        variables: payload,
      });
      if (res.data.createScheduledEmail.statusCode === 200) {
        message.success(res.data.createScheduledEmail.message);
        emailForm.resetFields();
        scheduleForm.resetFields();
        emailTextRef.current.innerHTML = "";
        getMessages();
        refetch();
        close();
      } else {
        message.error(res.data.createScheduledEmail.message);
      }
    }
  };

  return (
    <Form layout="vertical" form={scheduleForm} onFinish={handleSchedule}>
      <div className="flex-col-centered gap-2 -m-3">
        <div className="flex-row-centered p-3 gap-1">
          <Form.Item
            rules={[{ required: true, message: "Please select the date" }]}
            label="Date"
            className="w-full"
            name="date"
          >
            <DatePicker className="w-full" name="date" />
          </Form.Item>
          <Form.Item
            label="Time"
            className="w-full"
            rules={[{ required: true, message: "Please select the time" }]}
            name="time"
          >
            <TimePicker name="time" className="w-full" />
          </Form.Item>
        </div>
        <div className="p-3">
          <Form.Item
            rules={[{ required: true, message: "Please select the timezone" }]}
            name="timezone"
            label="Timezone"
          >
            <Select
              name="timezone"
              options={timezones.map(timezone => ({
                label: timezone.label,
                value: timezone.value,
              }))}
            />
          </Form.Item>
        </div>
        <div className="p-3 flex-row-centered gap-1 bg-grey-100">
          <Button
            onClick={() => {
              scheduleForm.resetFields();
              close();
            }}
          >
            Cancel
          </Button>
          <Button type="primary" loading={createScheduledEmailLoader} htmlType="submit">
            Schedule
          </Button>
        </div>
      </div>
    </Form>
  );
};
